// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.course-filter fieldset {
  max-width: 230px;
}

.totalprogress path.highcharts-point.highcharts-color-0 {
  fill: var(--primaryColor);
}

.totalprogress path.highcharts-color-1 {
  fill: #9d9c9c;
}

.filter-select fieldset {
  border: none !important;
}

.filter-sort-select fieldset {
  height: 43px;
  max-height: 43px;
  margin: 6px 0;
}

.filter-sort-select fieldset legend {
  display: none;
}`, "",{"version":3,"sources":["webpack://./js/lib/components/MyCoursesCardView/Filter/style.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;AACf","sourcesContent":[".course-filter fieldset {\r\n  max-width: 230px;\r\n}\r\n\r\n.totalprogress path.highcharts-point.highcharts-color-0 {\r\n  fill: var(--primaryColor);\r\n}\r\n\r\n.totalprogress path.highcharts-color-1 {\r\n  fill: #9d9c9c;\r\n}\r\n\r\n.filter-select fieldset {\r\n  border: none !important;\r\n}\r\n\r\n.filter-sort-select fieldset {\r\n  height: 43px;\r\n  max-height: 43px;\r\n  margin: 6px 0;\r\n}\r\n\r\n.filter-sort-select fieldset legend {\r\n  display: none;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
